import { DEFAULT_MAX_AGE, DEFAULT_MIN_AGE } from '../campaign.constant';
import { CampaignFiltersDTO, FilterType } from '../campaign.type';

export const EXCLUSIVE_TYPES: FilterType[] = [FilterType.NONE, FilterType.CLIENTS];
export const COMBINABLE_TYPES: FilterType[] = [FilterType.PROFILE, FilterType.CATEGORY];

const isCombinable = (type: FilterType) => COMBINABLE_TYPES.includes(type);

const carriesAgeConstraint = (filters: CampaignFiltersDTO) =>
  (filters.minAge != null && filters.minAge !== DEFAULT_MIN_AGE) ||
  (filters.maxAge != null && filters.maxAge !== DEFAULT_MAX_AGE);

export const hasActiveProfileFilter = (filters: CampaignFiltersDTO): boolean =>
  carriesAgeConstraint(filters) ||
  filters.gender != null ||
  filters.minLoyaltyPoints != null ||
  filters.maxLoyaltyPoints != null ||
  filters.minCollectedPoints != null ||
  filters.maxCollectedPoints != null ||
  filters.minNbPassageTransactions != null ||
  filters.maxNbPassageTransactions != null ||
  filters.minAverageBasket != null ||
  filters.maxAverageBasket != null ||
  filters.minWeeklyAverageBasket != null ||
  filters.maxWeeklyAverageBasket != null ||
  filters.startPassageDate != null ||
  filters.endPassageDate != null ||
  (filters.zipOrPostcodes?.length ?? 0) > 0 ||
  (filters.clientsAcquiredFrom?.length ?? 0) > 0 ||
  (filters.clientsTypes?.length ?? 0) > 0 ||
  filters.originProviderId != null ||
  filters.radius != null ||
  (filters.crmFieldFilters?.length ?? 0) > 0 ||
  (filters.consumedProductIds?.length ?? 0) > 0 ||
  filters.fromConnector === true;

export const hasAnyActiveFilter = (filters: CampaignFiltersDTO): boolean =>
  Boolean(filters.segmentRef) || (filters.clientIds?.length ?? 0) > 0 || hasActiveProfileFilter(filters);

export const normaliseFilterTypes = (types: FilterType[]): FilterType[] => {
  if (types.includes(FilterType.CLIENTS)) {
    return [FilterType.CLIENTS];
  }
  const combinable = types.filter(isCombinable);
  return combinable.length > 0 ? combinable : [FilterType.NONE];
};

export const toggleFilterType = (types: FilterType[], type: FilterType): FilterType[] => {
  if (!isCombinable(type)) {
    return normaliseFilterTypes([type]);
  }
  if (types.includes(type)) {
    return normaliseFilterTypes(types.filter(item => item !== type));
  }
  return normaliseFilterTypes([...types.filter(isCombinable), type]);
};

export const detectFilterTypes = (filters: CampaignFiltersDTO): FilterType[] => {
  if ((filters.clientIds?.length ?? 0) > 0) {
    return [FilterType.CLIENTS];
  }
  const types: FilterType[] = [];
  if (filters.segmentRef) {
    types.push(FilterType.CATEGORY);
  }
  if (hasActiveProfileFilter(filters)) {
    types.push(FilterType.PROFILE);
  }
  return types.length > 0 ? types : [FilterType.NONE];
};
